<template>
  <div class="installment-card">
    <div class="device-name">{{ $props.installmentData.deviceName }}</div>
    <div class="card-wrapper">
      <div class="data-wrapper">
        <div class="installment-title">{{ $t('monthlyInstallment.installmentTitle') }}</div>
        <span class="installment-amount">{{ $props.installmentData.formattedRateAmount}}</span>
      </div>
      <div class="data-wrapper">
        <div class="installment-title">{{ $t('monthlyInstallment.paidInstallmentTitle') }}</div>
        <span class="installment-amount">{{ $props.installmentData.payedRates }}/{{$props.installmentData.totalRates}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'monthly-installment-card',
  props: {
    installmentData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.installment-card {
  min-width: 320px;
  background-color: #ffffff;
  border-radius: 5px;
  padding: 26px 69px 24px 26px;
  margin-bottom: 0.8rem;

  .device-name {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.8;
  }

  .card-wrapper {
    display: flex;
    justify-content: space-between;

    .data-wrapper {
      display: flex;
      flex-direction: column;

      .installment-title {
        font-size: 1.4rem;
        line-height: 2.2;
      }

      .installment-amount {
        font-size: 1.4rem;
        color: $primary;
      }
    }
  }
}

</style>
